module.exports = __webpack_public_path__ + "static/media/Playlikeagirl.f9702f96.gif";